import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const OneNoteEduLogoInverseIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M1888 832q14 0 23 9t9 23v256q0 14-9 23t-23 9h-32V832h32zm0 384q14 0 23 9t9 23v256q0 14-9 23t-23 9h-32v-320h32zm0-768q14 0 23 9t9 23v256q0 14-9 23t-23 9h-96v912q0 20-14 34t-34 14h-528v-192h384v-64h-384v-128h384v-64h-384V829l240 87 159-64v138q0 7 5 11t12 5q7 0 12-4t5-12V840l64-28-258-115-239 94V320h528q20 0 34 14t14 34v80h96zm-435 624q16 0 34-1t36-7 32-14 25-24l-1-123q-5 2-24 9t-40 16-38 15-21 7q-39-12-77-26t-77-29q-1 26-1 53t-1 53q0 21 18 34t44 22 51 11 40 4zM128 307l1024-173v1780L128 1741V307zm285 1035l102 5V867l271 495 136 8V660l-127 8v351q0 31-1 62t1 63L543 683l-130 5v654z" />
    </svg>
  ),
  displayName: 'OneNoteEduLogoInverseIcon',
});

export default OneNoteEduLogoInverseIcon;
